import {
  getAccountToken,
  setAccountToken,
  setAccountName,
  setUserGroup,
  setUserId,
  setUserDistributorId,
  setUserDealerId,
  setUserAccessRoles,
  clearTempStorage,
} from "../utilities/storage";

// since we get the values by antd form, no need to use the email and password state to control the field.

export const initialState = {
  // email: "",
  // password: "",
  isLoading: false,
  error: "",
  isAuthenticated: getAccountToken() !== null,
};

export default function loginReducer(state, action) {
  switch (action.type) {
    // case "FIELD": {
    //   return {
    //     ...state,
    //     [action.fieldName]: action.payload,
    //   };
    // }
    case "LOGIN": {
      return {
        ...state,
        error: "",
        isLoading: true,
      };
    }
    case "SUCCESS": {
      const {
        token,
        first_name,
        group,
        id,
        distributor_id,
        dealer_id,
        access,
      } = action.payload;

      setAccountToken(token);
      setUserId(id);
      setUserDistributorId(distributor_id);
      setUserDealerId(dealer_id);
      setAccountName(first_name);
      setUserGroup(group);
      setUserAccessRoles(JSON.stringify(access));

      return {
        ...state,
        isLoading: false,
        isAuthenticated: true,
      };
    }
    case "ERROR": {
      return {
        ...state,
        error: "Incorrect username or password!",
        isLoading: false,
        // email: "",
        // password: "",
      };
    }
    case "LOGOUT": {
      clearTempStorage();
      return {
        ...state,
        // email: "",
        // password: "",
        isAuthenticated: false,
      };
    }
    default:
      return state;
  }
}
